import {
    IComponent, IComponentType, IControl, EComponentTypes, clone, ComponentHelper, IdHelper, IProcessState, IProperty, IComponentIdHolder, ISearchLocation, IBranch,
    IDecision, IAction, ISubmission, IComponentDictionary, IOutputValue, ISharedJourney, IRedirect, IControlBlock, ILoop, ILoopConfigSummaryColumn, getEntityOptionSetFromService, EConfirmationOperationType, IControlLayoutPanel
} from '../../helpers/';
import { DEFAULT_ACTION } from '../../constants';
import types from '../types';
import store from '../store';
import { Promise } from 'es6-promise';

const initialState: IProcessState = {
    components: {},
    sharedJourneyComponentCount: 0,
    nextOutputOrder: 0
};

const processReducer = function (state: IProcessState = initialState, action) {

    let stateClone: IProcessState = clone(state);

    switch (action.type) {

        case types.ADD_COMPONENT:
            stateClone = addComponent(stateClone, action.componentType, action.Id, action.searchLocation, action.properties, action.parentDecisionId,
                action.decisionTemplate, action.loopTemplate);
            break;

        case types.TOGGLE_COMPONENT_MENU:
            stateClone = toggleMenu(stateClone, action.componentId);
            break;

        case types.UPDATE_PROPERTY:
            stateClone = updateProperty(stateClone, action.componentId, action.key, action.value);
            break;

        case types.UPDATE_LAYOUT_PANEL_PROPERTY:
            stateClone = updateLayoutPanelProperty(stateClone, action.componentId, action.key, action.value, action.layoutPanelIndex);
            break;

        case types.UPDATE_COMPONENT_OUTPUT:
            stateClone = updateComponentOutput(stateClone, action.componentId, action.key);
            break;

        case types.UPDATE_CONTROL:
            stateClone = updateControl(stateClone, action.componentId, action.controlIndex, action.control, action.layoutPanelIndex);
            break;

        case types.ADD_CONTROL_TO_LAYOUT_PANEL:
            stateClone = addControlToLayoutPanel(stateClone, action.componentId, action.layoutPanelIndex, action.control);
            break;

        case types.DELETE_CONTROL:
            stateClone = deleteControl(stateClone, action.componentId, action.controlId, action.controlIndex, action.layoutPanelIndex);
            break;

        case types.DELETE_LAYOUT_PANEL:
            stateClone = deleteLayoutPanel(stateClone, action.componentId, action.layoutPanelIndex);
            break;

        case types.DROP_CONTROL:
            stateClone = moveControl(stateClone, action.componentId, action.fromIndex, action.toIndex);
            break;

        case types.DROP_CONTROL_WITH_LAYOUT_PANEL:
            stateClone = moveControlWithLayoutPanel(stateClone, action.componentId, action.fromIndex, action.toIndex, action.fromLayoutPanelIndex, action.toLayoutPanelIndex);
            break;

        case types.ADD_LAYOUT_PANEL:
            stateClone = addLayoutPanel(stateClone, action.componentId, action.layoutPanel);
            break;

        case types.SET_PROCESS_STATE:
            stateClone = setProcessState(stateClone, action.components, action.StartId);
            break;

        case types.UPDATE_PROCESS_STATE:
            stateClone = updateProcessState(stateClone, action.deletedOutputs);
            break;

        case types.DELETE_COMPONENT:
            stateClone = deleteComponent(stateClone, action.componentId);
            break;

        case types.SET_NEXT_COMPONENT_ID:
            stateClone = setNextComponentId(stateClone, action.componentId, action.nextComponentId);
            break;

        case types.SET_FIRST_LOOP_COMPONENT_ID:
            stateClone = setFirstLoopComponentId(stateClone, action.componentId, action.firstLoopComponentId);
            break;

        case types.REPLACE_NEXT_COMPONENT:
            stateClone = replaceNextComponentId(stateClone, action.componentIdToReplace, action.newNextComponent);
            break;

        case types.SET_NEXT_COMPONENT_ID_FOR_CONDITION:
            stateClone = setNextComponentIdForCondition(stateClone, action.branchId, action.componentId, action.nextComponentId);
            break;

        case types.UPDATE_ACTION:
            stateClone = updateAction(stateClone, action.componentId, action.action);
            break;

        case types.UPDATE_DECISION:
            stateClone = updateDecision(stateClone, action.componentId, action.decision);
            break;

        case types.UPDATE_SUBMISSION:
            stateClone = updateSubmission(stateClone, action.componentId, action.submission);
            break;

        case types.UPDATE_REDIRECT:
            stateClone = updateRedirect(stateClone, action.componentId, action.redirect);
            break;

        case types.ADD_SHARED_JOURNEY_OUTPUTS:
            stateClone = addSharedJourneyOutputs(stateClone, action.componentId, action.outputs);
            break;

        case types.UPDATE_SHARED_JOURNEY:
            stateClone = updateSharedJourney(stateClone, action.componentId, action.sharedJourney);
            break;

        case types.RESET_COMPONENTS:
            stateClone = resetComponents(stateClone);
            break;

        case types.DELETE_COMPONENT_CHAIN:
            stateClone = deleteComponentChain(stateClone, action.componentId);
            break;

        case types.UPDATE_CONTROL_BLOCK:
            stateClone = updateControlBlock(stateClone, action.controlBlock);
            break;

        case types.UPDATE_LOOP:
            stateClone = updateLoop(stateClone, action.componentId, action.outputValues, action.properties, action.summaryColumns);
            break;

        case types.UPDATE_LOOP_OUTPUT:
            stateClone = updateLoopOutput(stateClone, action.output);
            break;

        default:
            break;

    }

    return stateClone;

};

let addComponent = (state: IProcessState, type: IComponentType, Id: string, searchLocation: ISearchLocation, properties: IProperty[], parentDecisionId: string,
    decisionTemplate: IDecision, loopTemplate: ILoop): IProcessState => {

    let component: IComponent = { Id: Id, ComponentType: type, openMenu: false, ParentDecisionId: parentDecisionId, ParentLoopId: searchLocation.loopComponentId };

    ComponentHelper.setIsLeafComponent(component); //this will be true initially if there is a parentDecisionId, and will be set to false if a NextComponent is specified

    //TODO: set order

    switch (type.ComponentTypeId) {
        case EComponentTypes.action:
            component.Action = clone(DEFAULT_ACTION);
            component.Action.ComponentId = Id;
            break;
        case EComponentTypes.block:
            component.ControlBlock = { ComponentId: Id, Controls: [], LayoutPanels: [] };
            break;
        case EComponentTypes.step:
            component.Step = { ComponentId: Id };
            break;
        case EComponentTypes.decision:
            component.Decision = decisionTemplate;
            break;
        case EComponentTypes.sharedJourney:
            component.SharedJourney = { ComponentId: Id, OutputValues: [] };
            state.sharedJourneyComponentCount++;
            break;
        case EComponentTypes.summary:
            component.Summary = { ComponentId: Id, SummaryInformation: '' };
            break;
        case EComponentTypes.submission:
            component.Submission = { ComponentId: Id };
            break;
        case EComponentTypes.redirect:
            component.Redirect = { ComponentId: Id };
            break;
        case EComponentTypes.loop:
            component.Loop = loopTemplate
            break;
        default:
            break;
    }
    ComponentHelper.setProperties(component, clone(properties));

    if (component.ComponentType.ComponentTypeId === EComponentTypes.block)
        component.ControlBlock.Controls = [];

    if (searchLocation.branchId === 'root' && !state.StartId) {
        state.StartId = component.Id;
    }

    state.components[component.Id] = component;

    return state;

};

let toggleMenu = (state: IProcessState, componentId: string): IProcessState => {

    let component: IComponent = state.components[componentId];
    if (!component) {
        return state;
    }

    let isOpen: boolean = component.openMenu;

    let newComponents = clone(state.components);
    for (let Id in newComponents) {
        newComponents[Id].openMenu = false;
    }
    newComponents[componentId].openMenu = !isOpen;
    state.components = newComponents;

    return state;

};

let updateProperty = (state: IProcessState, componentId: string, key: string, value: any) => {

    let properties = ComponentHelper.getProperties(state.components[componentId]);
    let prop = properties.filter(prop => prop.Name === key)[0];

    if (!prop)
        return;

    prop.Value = value;

    return state;

};

let updateLayoutPanelProperty = (state: IProcessState, componentId: string, key: string, value: any, layoutPanelIndex: number) => {

    let properties = ComponentHelper.getProperties(state.components[componentId], true, true, layoutPanelIndex);
    let prop = properties.filter(prop => prop.Name === key)[0];

    if (!prop)
        return;

    prop.Value = value;

    return state;

};

let updateComponentOutput = (state: IProcessState, componentId: string, key: string) => {

    let outputs = ComponentHelper.getOutputs(state.components[componentId]);
    let properties = ComponentHelper.getProperties(state.components[componentId]);

    // get name of the action component
    const actionName = properties.filter(x => x.Name === 'Action Name')[0].Value;

    // set prefix to the action outputs
    outputs && outputs.forEach(element => {
        element.Name = element.StaticName + ' - ' + actionName
    });

    return state;

};

let updateControl = (state: IProcessState, componentId: string, controlIndex: number, control: IControl, layoutPanelIndex: number): IProcessState => {

    let component: IComponent = state.components[componentId];
    control.ComponentId = (control.ComponentId && control.ComponentId.length) ? control.ComponentId : component.Id;
    control.ControlId = control.ControlId.length ? control.ControlId : IdHelper.newGuid();

    if (control.OutputValues && control.OutputValues.length) {
        control.OutputValues.forEach(o => {
            if (o.Order === null) {
                o.Order = state.nextOutputOrder++;
            }
        })
    }

    if (controlIndex === null)
        component.ControlBlock.Controls.push(control);
    else {
        const indexInControls = component.ControlBlock.Controls.indexOf(component.ControlBlock.Controls.filter(x => x.ControlId === control.ControlId)[0]);
        component.ControlBlock.Controls[indexInControls] = control;
    }
    // component.ControlBlock.Controls[controlIndex] = control;

    if (layoutPanelIndex !== null && layoutPanelIndex !== undefined) {
        component.ControlBlock.LayoutPanels[layoutPanelIndex].Controls[controlIndex] = control;
    }

    return state;

};

let addControlToLayoutPanel = (state: IProcessState, componentId: string, layoutPanelIndex: number, control: IControl): IProcessState => {

    let component: IComponent = state.components[componentId];
    control.ComponentId = (control.ComponentId && control.ComponentId.length) ? control.ComponentId : component.Id;
    control.ControlId = control.ControlId.length ? control.ControlId : IdHelper.newGuid();

    if (control.OutputValues && control.OutputValues.length) {
        control.OutputValues.forEach(o => {
            if (o.Order === null) {
                o.Order = state.nextOutputOrder++;
            }
        })
    }

    if (layoutPanelIndex === null || layoutPanelIndex === undefined)
        component.ControlBlock.LayoutPanels && component.ControlBlock.LayoutPanels[component.ControlBlock.LayoutPanels.length - 1].Controls.push(control);
    else
        component.ControlBlock.LayoutPanels[layoutPanelIndex].Controls.push(control);

    return state;

};

let setProcessState = (state: IProcessState, components: IComponentDictionary, StartId: string): IProcessState => {

    for (let id in components) {
        state.components[id] = components[id];
        if (components[id].ComponentType.ComponentTypeId === EComponentTypes.sharedJourney) {
            state.sharedJourneyComponentCount++;
        }

        if (components[id].ComponentType.ComponentTypeId === EComponentTypes.action && components[id].Action.Properties) {
            let entity: IProperty = components[id].Action.Properties.filter(x => x.IsDependentDropdownSource)[0];
            if (entity) {
                let actionState = store.getState().modalState.actionConfig;

                var promise = new Promise((resolve, reject) => {

                    getEntityOptionSetFromService(entity.Value).then(
                        (response: any) => {
                            let optionSet = [];
                            Object.keys(response).map((val, index) => {
                                optionSet.push(
                                    {
                                        key: val,
                                        text: response[val]
                                    }
                                );
                            });
                            store.dispatch({
                                type: types.ADD_ENTITY_OPTION_SET,
                                entityOptionSet: optionSet
                            });
                            resolve(optionSet);
                        },
                        (error) => {
                            reject(error);
                        }
                    );

                });

            }
        }
    }
    state.StartId = StartId;

    return state;
};

let updateProcessState = (state: IProcessState, deletedOutputs: string[]): IProcessState => {

    function replaceAll(str: string, find: string, replace: string) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    let jsonJourney = JSON.stringify(state.components);

    if (deletedOutputs.length) {
        deletedOutputs.forEach(x => {
            jsonJourney = replaceAll(jsonJourney, "##" + x + "##", "");

            // remove deleted tokens from decision rules
            jsonJourney = replaceAll(jsonJourney, "<span[^>]*?output-id=[^>]*?" + x + ".*?span>.*?span>.*?span>", "");
            jsonJourney = replaceAll(jsonJourney, x, "");
        })

        const newProcessState = JSON.parse(jsonJourney);
        state.components = newProcessState;

        for (let id in newProcessState) {
            state.components[id] = newProcessState[id];
            if (newProcessState[id].ComponentType.ComponentTypeId === EComponentTypes.sharedJourney) {
                state.sharedJourneyComponentCount++;
            }

            if (newProcessState[id].ComponentType.ComponentTypeId === EComponentTypes.action && newProcessState[id].Action.Properties) {
                let entity: IProperty = newProcessState[id].Action.Properties.filter(x => x.IsDependentDropdownSource)[0];
                if (entity) {
                    let actionState = store.getState().modalState.actionConfig;

                    var promise = new Promise((resolve, reject) => {

                        getEntityOptionSetFromService(entity.Value).then(
                            (response: any) => {
                                let optionSet = [];
                                Object.keys(response).map((val, index) => {
                                    optionSet.push(
                                        {
                                            key: val,
                                            text: response[val]
                                        }
                                    );
                                });
                                store.dispatch({
                                    type: types.ADD_ENTITY_OPTION_SET,
                                    entityOptionSet: optionSet
                                });
                                resolve(optionSet);
                            },
                            (error) => {
                                reject(error);
                            }
                        );

                    });

                }

            }
        }
        return state;
    } else {
        return state;
    }
};

let deleteControl = (state: IProcessState, componentId: string, controlId: string, controlIndex: number, layoutPanelIndex: number): IProcessState => {

    // state.components[componentId].ControlBlock.Controls.splice(controlIndex, 1);
    state.components[componentId].ControlBlock.Controls = state.components[componentId].ControlBlock.Controls.filter(function (item) {
        return item.ControlId.toLowerCase() !== controlId.toLowerCase()
    })

    if (layoutPanelIndex !== null && layoutPanelIndex !== undefined) {
        state.components[componentId].ControlBlock.LayoutPanels[layoutPanelIndex].Controls.splice(controlIndex, 1);
    }
    return state;

};
let deleteLayoutPanel = (state: IProcessState, componentId: string, layoutPanelIndex: number): IProcessState => {
    if (state.components[componentId].ControlBlock.LayoutPanels[layoutPanelIndex].Controls.length) {
        state.components[componentId].ControlBlock.LayoutPanels[layoutPanelIndex].Controls.forEach(x => {
            state.components[componentId].ControlBlock.Controls = state.components[componentId].ControlBlock.Controls.filter(function (item) {
                return item.ControlId.toLowerCase() !== x.ControlId.toLowerCase()
            })

        })
    }

    state.components[componentId].ControlBlock.LayoutPanels.splice(layoutPanelIndex, 1);
    return state;

};

let moveControl = (state: IProcessState, componentId: string, fromIndex: number, toIndex: number): IProcessState => {

    let component: IComponent = state.components[componentId];
    let control: IControl = clone(component.ControlBlock.Controls[fromIndex]);

    component.ControlBlock.Controls.splice(fromIndex, 1);
    component.ControlBlock.Controls.splice(toIndex, 0, control);

    return state;

};

let moveControlWithLayoutPanel = (state: IProcessState, componentId: string, fromIndex: number, toIndex: number, fromLayoutPanelIndex: number, toLayoutPanelIndex: number): IProcessState => {

    let component: IComponent = state.components[componentId];
    // let control: IControl = clone(component.ControlBlock.Controls[fromIndex]);
    let control: IControl = clone(component.ControlBlock.LayoutPanels[fromLayoutPanelIndex].Controls[fromIndex]);

    // component.ControlBlock.Controls.splice(fromIndex, 1);
    // component.ControlBlock.Controls.splice(toIndex, 0, control);

    if (component.ControlBlock.LayoutPanels) {
        component.ControlBlock.LayoutPanels[fromLayoutPanelIndex].Controls.splice(fromIndex, 1);

        if (component.ControlBlock.LayoutPanels[toLayoutPanelIndex].Controls && component.ControlBlock.LayoutPanels[toLayoutPanelIndex].Controls.length) {
            component.ControlBlock.LayoutPanels[toLayoutPanelIndex].Controls.splice(toIndex, 0, control)
        } else {
            component.ControlBlock.LayoutPanels[toLayoutPanelIndex].Controls.push(control);
        }
    }

    return state;

};

let addLayoutPanel = (state: IProcessState, componentId: string, layoutPanel: IControlLayoutPanel[]): IProcessState => {
    let component: IComponent = state.components[componentId];
    if (component.ControlBlock.LayoutPanels)
        component.ControlBlock.LayoutPanels = component.ControlBlock.LayoutPanels.concat(layoutPanel);
    return state;
};


let deleteComponent = (state: IProcessState, componentId: string): IProcessState => {

    if (state.components[componentId].ComponentType.ComponentTypeId === EComponentTypes.sharedJourney) {
        state.sharedJourneyComponentCount--;
    }

    delete state.components[componentId];

    return state;

};

let setFirstLoopComponentId = (state: IProcessState, componentId: string, firstLoopComponentId: string) => {

    state.components[componentId].Loop.FirstLoopComponent = { ComponentId: firstLoopComponentId };

    return state;

}

let setNextComponentId = (state: IProcessState, componentId: string, nextComponentId: string): IProcessState => {

    let component: IComponent = state.components[componentId];

    component.NextComponent = nextComponentId ? { "ComponentId": nextComponentId } : null;

    ComponentHelper.setIsLeafComponent(component);
    return state;
};

let replaceNextComponentId = (state: IProcessState, componentIdToReplace: string, newNextComponent: IComponentIdHolder): IProcessState => {

    ComponentHelper.replaceNextComponentId(state.components, componentIdToReplace, newNextComponent);

    return state;
};

let setNextComponentIdForCondition = (state: IProcessState, branchId: string, componentId: string, nextComponentId: string): IProcessState => {

    let decision: IComponent = state.components[componentId];
    let condition: IBranch = decision.Decision.Branches.filter((c, i) => {
        let conditionId: string = IdHelper.getConditionId(componentId, i);
        return branchId === conditionId;
    })[0];

    if (condition)
        condition.NextComponent = { ComponentId: nextComponentId };

    return state;
};

let updateAction = (state: IProcessState, componentId: string, action: IAction) => {
    action.ComponentId = componentId;

    if (action.OutputValues && action.OutputValues.length) {
        action.OutputValues.forEach(o => {
            if (o.Order === null) {
                o.Order = state.nextOutputOrder++;
            }
        })
    }

    state.components[componentId].Action = action;
    return state;
};

let updateDecision = (state: IProcessState, componentId: string, decision: IDecision) => {

    //update the Decision property of the component
    state.components[componentId].Decision = decision;
    return state;
};

let updateSubmission = (state: IProcessState, componentId: string, submission: ISubmission) => {
    state.components[componentId].Submission = submission;
    return state;
};

let updateRedirect = (state: IProcessState, componentId: string, redirect: IRedirect) => {
    state.components[componentId].Redirect = redirect;
    return state;
};

let addSharedJourneyOutputs = (state: IProcessState, componentId: string, outputs: IOutputValue[]) => {
    state.components[componentId].SharedJourney.OutputValues = outputs.map((v) => {
        let output = { ...v };
        if (output.Order === null) {
            output.Order = state.nextOutputOrder++;
        }
        delete output.componentId;
        return output;
    });
    return state;
};

let updateSharedJourney = (state: IProcessState, componentId: string, sharedJourney: ISharedJourney) => {

    state.components[componentId].SharedJourney = sharedJourney;
    return state;
};

let resetComponents = (state: IProcessState) => {
    state = initialState;
    return state;
};

let deleteComponentChain = (state: IProcessState, componentId: string) => {
    //delete the components in the chain that starts from componentId
    while (componentId) {
        let component = state.components[componentId];

        if (component.ComponentType.ComponentTypeId === EComponentTypes.decision) {
            for (let i = 0; i < component.Decision.Branches.length; i++) {
                if (component.Decision.Branches[i].NextComponent && component.Decision.Branches[i].NextComponent.ComponentId) {
                    state = deleteComponentChain(state, component.Decision.Branches[i].NextComponent.ComponentId);
                }
            }
        }

        componentId = component.NextComponent ? component.NextComponent.ComponentId : null;
        if (component.ComponentType.ComponentTypeId === EComponentTypes.sharedJourney) {
            state.sharedJourneyComponentCount--;
        }
        delete state.components[component.Id];
    }
    return state;
};

let updateControlBlock = (state: IProcessState, controlBlock: IControlBlock): IProcessState => {
    state.components[controlBlock.ComponentId].ControlBlock = controlBlock;
    return state;
}

let updateLoop = (state: IProcessState, componentId: string, outputValues: IOutputValue[], properties: IProperty[], summaryColumns: ILoopConfigSummaryColumn[]) => {

    state.components[componentId].Loop.ComponentId = componentId;
    state.components[componentId].Loop.OutputValues = outputValues;
    state.components[componentId].Loop.Properties = properties;
    state.components[componentId].Loop.SummaryColumns = summaryColumns;

    return state;
}

let updateLoopOutput = (state: IProcessState, output: IOutputValue) => {

    let component = state.components[output.componentId];

    if (component && component.Loop) {

        component.Loop.OutputValues = component.Loop.OutputValues.map(o => {

            if (o.Id === output.Id) {
                return output;
            }

            return o;

        });

    }

    return state;
}

export default processReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/process.ts